import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { ContentfulService } from '../contentful.service';
import { Entry } from 'contentful';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit {

  settings: Entry<any>;
  constructor(private cookie: CookieService, private contentfulService: ContentfulService) { 

  }

  public locale: string;

  langSelect(lang){
    this.cookie.set('locale', lang);
    // console.log('cookie stored. lang = ' + this.cookie.get('locale'));
    location.reload();
  }

  openMenu(){
    console.log('clicked');
    var menuId = document.getElementById('menu-icon');
    var mainMenu = document.getElementById('main-menu');
    menuId.classList.toggle('open');
    mainMenu.classList.toggle('is-open');
  }

  closeMenu(){
    console.log('close');
    var menuId = document.getElementById('menu-icon');
    var mainMenu = document.getElementById('main-menu');
    menuId.classList.toggle('open');
    mainMenu.classList.toggle('is-open');
  }

  ngOnInit(): void {
    // if no lang selected language
    if(this.cookie.get('locale') === undefined || !this.cookie.get('locale')){
      //set default 
      this.cookie.set('locale', 'fr');
      // console.log(this.cookie.get('locale'))
    }		
    
    // set for selected on page
    this.locale = this.cookie.get('locale');
    var locale = this.cookie.get('locale');
    // Get page settings
		this.contentfulService.getPage(locale, 'settings', '2ExNEl8vKOI8qB6MbABmEn')
		.then((settings) => {
			this.settings = settings;
			// console.log(this.settings);
		});
  }
}